import { repository, baseURL } from '@/api/base'
import { Report } from '@/models'

export default {
  async getCatalog() {
    let reports = []
    reports.push(new Report(77, 'reportForWork', 'Отчет по работам'))
    reports.push(new Report(78, 'publicationSample', 'Отчет по публикациям'))
    reports.push(new Report(79, 'disMember', 'Отчет по участию  в работе диссертационных советов'))
    return reports
  },

  async export(report) {
    const { data } = await repository.post(baseURL + '/xlsx/report' + report.name, {}, { responseType: 'arraybuffer' })
    return data
  }
}
